import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { downloadCollarTemplate } from "store/state/cashflows";

const DownloadCollarTemplate = props => (
  <SecondaryButton onClick={() => props.downloadCollarTemplate({ hedgeId: props.hedgeId })}>Collar Template</SecondaryButton>
);

export default connect(null, {
  downloadCollarTemplate
})
(DownloadCollarTemplate);
